export const TRANSACTION_CATEGORY = {
  ADMIN_ADJUSTMENT: 'A',
  PURCHASE_JERSIUM: 'J',
  PURCHASE_MARKETPLACE: 'P',
  FUNDS: 'F',
  SUPPORT_TICKET: 'T',
};
